import styles from "./OverviewView.module.scss";
import { View, ViewHeader } from "@/components";
import { OverviewActivityGrid } from "../overview-activity-grid";
import { OverviewStatistics } from "../overview-statistics";

export const OverviewView = () => {
  return (
    <View>
      <div className={styles["comp__content"]}>
        <ViewHeader
          heading="Overview"
          description="Lorem Ipsum is simply dummy text of the printing and typesetting industry. </br> Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
        />

        <OverviewStatistics />

        <OverviewActivityGrid />
      </div>
    </View>
  );
};
